import { View } from '../compiler'

import { typoStyles } from '../constants'
import { useTranslationContext } from '../context/general-translations'
import MarkdownText from './MarkdownText'
import RowListItem from './RowListItem'
import AcademicCapIcon from './heroicons/mini/AcademicCapIcon'

const DiscussionQuestions = ({ style, questions }) => {
  const { tGeneral } = useTranslationContext()

  return (
    <View style={style}>
      <MarkdownText
        style={[typoStyles.T2MediumBlue, { textTransform: 'uppercase' }]}
      >
        {tGeneral('discussion_questions_label')}
      </MarkdownText>
      <View style={{ marginTop: 12, flexDirection: 'column', rowGap: 12 }}>
        {questions.map((question, index) => (
          <RowListItem key={index} Icon={AcademicCapIcon} text={question} />
        ))}
      </View>
    </View>
  )
}

export default DiscussionQuestions
